import DtoOperationReferencial from './DtoOperationReferencial'

export default class DtoRemark extends DtoOperationReferencial {
    constructor(obj) {
        super(obj)
    }
}
